var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mcv-article-form',{attrs:{"initial-values":_vm.initialValues,"errors":_vm.validationErrors,"is-submitting":_vm.isSubmitting},on:{"articleSubmit":_vm.onSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }